import { module } from 'angular';
import component from './kelse.component';
import './kelse.scss';

export default module('app.kelse', [])
	.component('kelse', component)
	.name;
